<template>
<div>
  <div v-show="loginStep == 1">
    <masked-input ref="Phone"
      :label="$vuetify.lang.t('$vuetify.login.phoneNumber')"
      prefix="(+1) "
      :hint="giftCardMigration ? $vuetify.lang.t('$vuetify.migrate.phoneHint') : $vuetify.lang.t('$vuetify.forms.billing.phoneHint')"
      icon="phone"

      mask="phoneNumber"
      validation="validatePhone"
      :error-messages="errors['phoneError']"
      :raw.sync="telephone"
      limitRawLength="10"
    />

          <v-btn style="width: 100%" color="primary" :loading="inprogress" @click="onLogin">
            <slot name="continue">
              {{ skipLoginBeforeSpinning ? $vuetify.lang.t('$vuetify.common.continue') : $vuetify.lang.t('$vuetify.login.login') }}
            </slot>
          </v-btn>
        </div>
        
        <div v-show="loginStep == 2">
          <masked-input ref="txtVerifyCode"
            :label="$vuetify.lang.t('$vuetify.forms.billing.sixDigitCode')"
            icon="tag"
            :error-messages="errors['codeError']"
            :raw.sync="loginCode"
            limitRawLength="6"
          />

          <v-btn style="width: 100%" color="primary" :loading="inprogress" @click="onVerifyCode">
            <slot name="continue">
              {{ $vuetify.lang.t('$vuetify.login.verifyCode') }}
            </slot>
          </v-btn>
        </div>
</div>
</template>

<script>
import maskedInput from '../common/maskedInput'

import { mapGetters, mapMutations } from 'vuex';
import { api } from '@/plugins/api.service'

export default {
  components: { maskedInput },

  data: () => ({
    telephone: null,
    loginCode: null,
    errors: {},

    inprogress: false,

    loginStep: 1,
    giftCardMigration: false
  }),
  mounted() {
    const store = this.getStore
    if (store.groupId == 'G21800') {
      this.giftCardMigration = true;
      if (!this.guestDetails && this.getAuthToken) {
        this.getRecords()
      }
    }
  },
  computed: {
    ...mapGetters(['getStore']),
    
    skipLoginBeforeSpinning() {
      return this.getStore?.settings?.luckyWheelSettings?.skipLoginBeforeSpinning === true;
    }
  },

  methods: {
    loginRequest(telephone) {
      return api.post('/owa/customer/login/request', { telephone })
    },

    onLogin() {
      if (!this.telephone || this.telephone.length != 10) {
        this.$set(this.errors, 'phoneError', 'Invalid Telephone')
        return
      } else if (this.errors.phoneError) {
        this.$delete(this.errors, 'phoneError')
      }

      this.inprogress = true

      if (this.skipLoginBeforeSpinning) {
        this.setGuestTelephone(this.telephone);
        this.inprogress = false;
        this.$emit('loginComplete');
      } else {
        this.loginRequest(''+this.telephone)
          .then(() => {
            this.loginStep = 2
          })
          .catch(() => {
            this.$set(this.errors, 'phoneError', 'Invalid Telephone')
          })
          .finally(() => {
            this.inprogress = false
          })
      }
    },

    login(payload) {
      return api.post('/owa/customer/login', payload)
    },
    onVerifyCode() {
      if (!this.loginCode || this.loginCode.length != 6) {
        this.$set(this.errors, 'codeError', 'Invalid Code')
        return
      } else if (this.errors.codeError) {
        this.$delete(this.errors, 'codeError')
      }

      this.inprogress = true
      this.login({ telephone: this.telephone, code: this.loginCode }).then(res => {
        this.setAuthUser({
          ...(res.data || {}),
          'telephone': this.telephone,
          'authToken': res.headers.authorization
        })
        this.$parent.fetchCoupons()
        this.$emit('loginComplete');
      }).catch(() => {
        this.$set(this.errors, 'codeError', 'Invalid Code')
      }).finally(() => {
        this.inprogress = false
      })
    },

    ...mapMutations(['setAuthUser', 'setGuestTelephone'])
  }
}
</script>
